// client/src/pages/Weddings/steps/ReviewStep/ReviewDessertsSummary.jsx
import React from "react";
import { Card, CardContent, Typography, Grid, Stack } from "@mui/material";
import { SUBCATEGORY_META } from "../DessertsStep/utils/constants";
import { money } from "../../../../utils/money";

export default function ReviewDessertsSummary({
  dessertLines,
  hasDess,
  selections = [],
  total,
}) {
  // Total pieces
  const totalPieces = selections.reduce(
    (s, d) => s + (Number(d.quantity) || 0),
    0
  );

  // Build rows
  let rows = [];
  if (Array.isArray(dessertLines) && dessertLines.length > 0) {
    rows = dessertLines
      .filter((l) => Number(l.quantity) > 0)
      .map((l, idx) => {
        const subKey =
          l.subcategoryKeySnapshot || l.subcategory || l.subcategoryKey || "";
        const subLabel =
          l.subcategoryLabelSnapshot ||
          SUBCATEGORY_META[subKey]?.label ||
          subKey ||
          "";
        const name =
          l.displayName ||
          l.name ||
          l.title ||
          l.productId ||
          l.id ||
          "Dessert";
        return {
          key: `${l.productId || l.id || "line"}-${idx}`,
          display: subLabel ? `${subLabel} • ${name}` : name,
          qty: Number(l.quantity) || 0,
          itemsPerSet: Number(l.itemsPerSet) || null,
        };
      });
  } else if (Array.isArray(selections) && selections.length > 0) {
    rows = selections
      .filter((s) => Number(s.quantity) > 0)
      .map((s, idx) => {
        const subKey =
          s.subcategoryKeySnapshot || s.subcategory || s.subcategoryKey || "";
        const subLabel =
          s.subcategoryLabelSnapshot ||
          SUBCATEGORY_META[subKey]?.label ||
          subKey ||
          "";
        const name =
          s.displayNameSnapshot ||
          s.name ||
          s.title ||
          s.patisserieId ||
          "Dessert";
        return {
          key: `${s.patisserieId || "sel"}-${idx}`,
          display: subLabel ? `${subLabel} • ${name}` : name,
          qty: Number(s.quantity) || 0,
          itemsPerSet: Number(s.itemsPerSet) || null,
        };
      });
  }

  console.log(hasDess);

  if (!hasDess) return null;

  return (
    <Card variant="outlined" sx={{ borderRadius: 3, mb: 2 }}>
      <CardContent sx={{ p: 2.25 }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            Single-serve desserts
            {totalPieces > 0 ? ` • ${totalPieces} pcs` : ""}
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
            {money(total)}
          </Typography>
        </Stack>

        {rows.length > 0 ? (
          <Grid container spacing={1} sx={{ mt: 0.5 }}>
            {rows.map((line) => (
              <Grid item xs={12} sm={6} key={line.key}>
                <Typography variant="body2">{line.display}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Qty: {line.qty}
                </Typography>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            No items selected yet.
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
